const itemContainer = document.querySelector('.prd-List_Items')
const firstProductCard = itemContainer.querySelector(
  '.prd-List_Item:not(.clc-PromotedCard) .prd-Card',
)

const firstCardItem = itemContainer.querySelector(
  '.prd-List_Item:not(.clc-PromotedCard) .prd-Card_Images',
)

const updateCardImageHeight = () => {
  const doubleCardFooter =
    firstProductCard.offsetHeight - firstCardItem.offsetHeight
  const doubleImageHeight =
    firstProductCard.offsetHeight * 2 + 20 - doubleCardFooter

  const height = firstCardItem.offsetHeight
  if (height > 0) {
    itemContainer.style.setProperty('--card-image-height', `${height}px`)
    itemContainer.style.setProperty(
      '--card-double-height',
      `${doubleImageHeight}px`,
    )
  }
}

updateCardImageHeight()

const resizeObserver = new ResizeObserver(() => {
  updateCardImageHeight()
})

resizeObserver.observe(firstCardItem)

window.addEventListener('beforeunload', () => {
  resizeObserver.disconnect()
})
